import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';

export interface DecodedToken {
  email?: string;
  type?: string;
  exp?: number;
}

export interface TokenInfo {
  isValid: boolean;
  isExpired: boolean;
  email?: string;
  type?: string;
  code?: string;
}

@Injectable({
  providedIn: 'root',
})
export class JwtDecodeService {
  constructor() {}

  decode(token: string): any | null {
    try {
      return jwt_decode.jwtDecode(token);
    } catch (err) {
      return null;
    }
  }

  isExpired(token: string): boolean {
    const decoded = this.decode(token);
    if (!decoded?.exp) return true;
    const now = Math.floor(Date.now() / 1000);
    return decoded.exp < now;
  }

  getTokenInfo(token: string): TokenInfo {
    const decoded = this.decode(token);

    if (!decoded) {
      return {
        isValid: false,
        isExpired: true,
      };
    }

    const expired = this.isExpired(token);

    return {
      isValid: true,
      isExpired: expired,
      email: decoded.email,
      type: decoded.type,
      code: decoded.code,
    };
  }
}
